import { i18n } from '@/plugins/i18n'

export const allotmentStatus = {
    ACTIVE: 1,
    INACTIVE: 0,
}

export const allotmentStatusStr = {
    ACTIVE: i18n.t('allotment.active'),
    INACTIVE: i18n.t('allotment.inactive'),

    get(status) {
        let status_str = null;

        Object.keys(allotmentStatus).forEach(item => {
            if(allotmentStatus[item] === status) {
                status_str = allotmentStatusStr[item];
            }
        });

        return status_str;
    }
}
